 export const location = {
    "RKSS" : 
    {
        name: "김포공항",
        iata:"GMP",
        id: "RKSS",
        pos: [126.75387496148681, 37.61957959705802],
        elevation : 6000,
        pitch : -90.0,
        heading : -135, 
        img :require("..//img/airport/RKSS.jpg"),
        isTrackEnabled: true, 
    },
    
    "RKPC" : {
        name: "제주공항",
        id: "RKPC",
        iata:"CJU",
        pos: [126.4463452862585, 33.55784649603555],
        elevation : 7000,
        pitch : -90.0,
        heading : -32,
        img :require("..//img/airport/RKPC.jpg"),
        isTrackEnabled: true, 
    },
    "RKPK" : {
        name: "김해공항",
        id: "RKPK",
        iata:"PUS",
        pos: [128.9313, 35.21149],
        elevation : 13,
        pitch : -135,
        heading : -90.0, 
        img :require("..//img/airport/RKPK.jpg"),
        isTrackEnabled: false, 
    },
    /*
    "RKSI" : {
        name: "인천공항",
        id: "RKSI",
        pos: [126.44107064, 37.4683951],
        elevation : 10000,
        pitch : -90.0,
        heading : -125.5,
        img :require("..//img/airport/RKSI.jpg"),
        isTrackEnabled: true, 
    }, 

    "RKJY" : {
        name: "여수공항",
        id: "RKJY",
        pos:  [127.6087, 34.83044],
        elevation : 53,
        pitch : -135,
        heading : -90.0, 
        img :require("..//img/airport/RKJY.jpg"),
        isTrackEnabled: false, 
    }, 
    "RKPU" : {
        name: "울산공항",
        id: "RKPU",
        pos: [129.3504, 35.58361],
        elevation : 42,
        pitch : -135,
        heading : -90.0, 
        img :require("..//img/airport/RKPU.jpg"),
        isTrackEnabled: false, 
    }
    */
}